import { faChevronLeft, faTimes } from '@fortawesome/pro-light-svg-icons';

import { Icon } from '@/components/ui/icon.component';
import { SheetClose, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { StepKeys } from '@/app/(main)/_components/sign-in-modal/_types/header-auth-modal-step-keys.enum';
import { useProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.hook';
import { ForgotPassword } from '@/app/(main)/_components/sign-in-modal/_components/forgot-password.component';

export default function ForgotPasswordStep() {
  const { handleJump: jump } = useProgressiveModal<StepKeys>();
  return (
    <div className="h-full flex flex-col md:min-h-[32rem]">
      <SheetHeader className="bg-white">
        <div className="flex justify-between gap-3 pb-6 items-center">
          <div className="flex gap-3">
            {jump && (
              <div className="flex justify-center w-[30px] h-[30px]">
                <Icon
                  icon={faChevronLeft}
                  className="cursor-pointer text-gray-500 text-base self-center"
                  onClick={() => jump({ key: StepKeys.LOGIN, returning: true })}
                />
              </div>
            )}
            <SheetTitle>
              <div className="flex gap-3">
                <span className="font-extrabold text-2xl text-gray-900 text-nowrap">Esqueceu a senha?</span>
              </div>
            </SheetTitle>
          </div>
          <SheetClose asChild className="text-gray-500 cursor-pointer self-center px-2 hover:bg-gray-50">
            <Icon icon={faTimes} size="xl" className="hover:text-gray-900 text-[1.625rem]" />
          </SheetClose>
        </div>
      </SheetHeader>
      <div className="pb-6">
        <ForgotPassword />
      </div>
    </div>
  );
}
